const About = () => {
    return (
        <section>
            <h2>About</h2>
            <p>This is an example route rendered by React Router.</p>
        </section>
    );
};

export default About;
